import * as React from 'react';
import Icon from 'react-fa';
import StarRatingComponent from 'react-star-rating-component';

const RenderStarIcon = (index, value, name) => value >= index ? <Icon name='star' /> : <Icon name='star-o' />
const Stars = ({name, value, editing}) => (
		<StarRatingComponent
				name={name}
				value={value}
				starCount={5}
				starColor="blue"
				emptyStarColor="darkgrey"
				editing={false}
				renderStarIcon={RenderStarIcon} />
);

export default Stars;



// WEBPACK FOOTER //
// ./src/app/containers/Place/common.tsx